module.exports = __webpack_public_path__ + "static/marionette-2bbd3b5e0ef3dfb962ba489408403bb7.jpg";